import FJConfig from '../config/FJConfig';
import $ from 'jquery';

const ajaxPoster = function (options) {
    let {url, data, success, error, complete, timeout} = options;
    if (!data) data = {};
    // if (window.csrf_token) data[window.csrf_token] = 1;
    try {
        let r = null;
        if (timeout) {
            r = $.ajax(url, {
                type: 'POST',
                data: data,
                timeout: timeout,
                success: success ? success : () => {
                },
                error: error ? error : () => {
                },
                complete: complete ? complete : (XMLHttpRequest,status) => {
                    if(status ==='timeout'){ //超时,status还有success,error等值的情况
                        error()
                    }
                }
            });
        } else {
            r = $.ajax(url, {
                type: 'POST',
                data: data,
                success: success ? success : () => {
                },
                error: error ? error : () => {
                },
                complete: complete ? complete : () => {
                },
            });
        }
        return r;
    } catch (e) {
        if (error) {
            error();
        }
    }
};


export default {
    // 检查账号是否存在
    checkAccountExist(data) {
        return new Promise((resolve, reject) => {
            ajaxPoster({
                url: FJConfig.requestPath + '/user/check-email',
                data: {
                    email: data.email
                },
                success: data => {
                    resolve(data);
                },
                error: e => {
                    reject(e);
                },
            });
        });
    },
// 获取城市code
    getUserCountryCode(data) {
        return new Promise((resolve, reject) => {
            ajaxPoster({
                url: 'https://www.cloudflare.com/cdn-cgi/trace',
                data: {},
                timeout: 3000,
                success: data => {
                    let localCountryCode = data.split('\n')[9].match(/=(.*)/)[1];
                    resolve(localCountryCode);
                },
                error: e => {
                    reject(e);
                },

            });
        });
    },

}
